export const pieza = {
  LR: [
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 1, 1],
    // [0, 0, 1, 1, 1, 1],
    [0, 0, 0, 0],
    [0, 0, 1, 0],
    [0, 0, 1, 0],
    [0, 1, 1, 0],
  ],
  LL: [
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [1, 1, 1, 1, 0, 0],
    // [1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 1, 0],
    [0, 0, 1, 0],
    [0, 0, 1, 1],
  ],
  Z: [
    // [1, 1, 1, 1, 0, 0],
    // [1, 1, 1, 1, 0, 0],
    // [0, 0, 1, 1, 1, 1],
    // [0, 0, 1, 1, 1, 1],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 1, 1, 0],
    [0, 0, 1, 1],
  ],
  S: [
    // [0, 0, 1, 1, 1, 1],
    // [0, 0, 1, 1, 1, 1],
    // [1, 1, 1, 1, 0, 0],
    // [1, 1, 1, 1, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 1, 1],
    [0, 1, 1, 0],
  ],
  Q: [
    // [0, 1, 1, 1, 1, 0],
    // [0, 1, 1, 1, 1, 0],
    // [0, 1, 1, 1, 1, 0],
    // [0, 1, 1, 1, 1, 0],
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 1, 1],
    [0, 0, 1, 1],
  ],
  I: [
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0]
    [0, 0, 1, 0],
    [0, 0, 1, 0],
    [0, 0, 1, 0],
    [0, 0, 1, 0],
  ],
  T: [
    // [0, 0, 1, 1, 0, 0],
    // [0, 0, 1, 1, 0, 0],
    // [1, 1, 1, 1, 1, 1],
    // [1, 1, 1, 1, 1, 1]
    [0, 0, 0, 0],
    [0, 0, 0, 0],
    [0, 0, 1, 0],
    [0, 1, 1, 1],
  ],
};

//rotacion de matriz 
//no hay velocidad solo actualizacion de posicion